import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import { ToastContainer, toast } from 'react-toastify';
import Papa from "papaparse";
import { useUser } from '../../context/UserContext';
import MODEL_LIST from '../../partials/models/model-list';
import LIST_MODAL from '../../partials/models/list-modal';
import EDIT_MODEL_MODAL from '../../partials/models/edit-model-modal';

const Models = () => {
	//***********//
	const navigate = useNavigate()
	const { user } = useUser()
	let [csvData, setCsvData] = useState([])
	let [csvError, setCsvError] = useState([])
	let [csvFile, setCsvFile] = useState([])
	let [searchTerm, setSearchTerm] = useState([])
	let [isListModalOpen, setListModalOpen] = useState(false)
	let [isEditModalOpen, setEditModalOpen] = useState(false)
	let [selectedModel, setSelectedModel] = useState(null)
	let [userModels, setUserModels] = useState([])
	let [userLists, setUserLists] = useState([])
	let [modelFilter, setModelFilter] = useState([])
	let [listFilter, setListFilter] = useState("")
	let [showFilters, setShowFilters] = useState(false)
	const allowedExtensions = ["csv"];

	const [inputValue, setInputValue] = useState({
		name: "",
		status: "not-started",
		list: "",
		points:""
	})

	const handleCsvFileChange = (e) => {
		setCsvError('')

		if(e.target.files.length) {
			const inputCsvFile = e.target.files[0]

			const fileExtension = inputCsvFile?.type.split("/")[1]
			if(!allowedExtensions.includes(fileExtension)) {
				setCsvError("Please make sure you upload a .csv file. Use the template file provided.")
				return false
			}

			setCsvFile(inputCsvFile)
		}
	}

	const handleCsvParse = (e) => {

		if(!csvFile) {
			setCsvError("Please upload a .csv file. Use the template file provided.")
		}

		const csvReader = new FileReader()

		csvReader.onload = async({target}) => {
			const csv = Papa.parse(target.result, {
				header: true
			})
			const parsedData = csv?.data
			const rows = Object.keys(parsedData)
			setCsvData(parsedData)
		}
		csvReader.readAsText(csvFile)
	}

	async function importModelsFromCSV() {
		if (!csvData || csvData.length === 0) return;
		try {
		// get csvData, which is our CSV data (obviously) parsed into an array containing
		// 'Name', 'Points', 'List', 'Status'
		//console.log(csvData)
		let uniqueList = []
			try {
				// console.log('csvData follows:')
				// console.log(csvData)
				const uniqueLists = [...new Set(csvData?.map(row => row.List))]
				// console.log('uniqueLists follows:')
				// console.log(uniqueLists)
				const {data} = await axios.post(
					`${process.env.REACT_APP_WEB_URL}api/lists/create-or-fetch-id`,
					{
						 
						uniqueLists 
					},
					{withCredentials:true}
				)
				// console.log('data to follow:')
				// console.log(data)
				const {uniqueList} = data
				// console.log('uniqueList to follow (this is within the try):')
				// console.log(uniqueList)

				// First things first, get all unique Lists, create any that don't exist already for this user,
				// then get and return the IDs of all Lists. You can use https://mongoosejs.com/docs/api/model.html#Model.findOneAndUpdate()

				// Add Models to their respective Lists, with points, with statuses, etc.
				let listReference = []
				// console.log('uniqueList to follow:')
				// console.log(uniqueList)
				uniqueList?.map((list) => {
					listReference[list.name] = list._id
				})
				//console.log(listReference)

				csvData?.map((item) => {
					item.List = listReference[item.List]
					//console.log(item)
				})

				//console.log(csvData)

				const {data: importModelData} = await axios.post(
					`${process.env.REACT_APP_WEB_URL}api/models/import-models`,
					{
						 
						csvData: csvData
					},
					{withCredentials:true}
				)
				if(importModelData) {
					handleSuccess("Models successfully imported from CSV!")
					getUserModels()
				}
			} catch(error) {
				console.log(error)
			}
		}
		catch(error) {
			console.log(error)
		}
	}

	useEffect(() => {
		importModelsFromCSV()
	}, [csvData])



	const {name,status,list,points} = inputValue;
	const handleOnChange = (e) => {
		const {name,value} = e.target
		setInputValue({
			...inputValue,
			[name]:value
		})
	}
	const handleOnSelectChange = (e) => {
		const {name,value} = e.target
		setInputValue({
			...inputValue,
			[name]:value
		})
	}
	const handleError = (error) =>
		toast.error(error, {
			position:"top-right"
		})
	const handleSuccess = (message) =>
		toast.success(message, {
			position:"top-right"
		})
	const handleAddModelSubmit = async(e) => {
		e.preventDefault()
		try {
			const {data} = await axios.post(
				`${process.env.REACT_APP_WEB_URL}api/models/add-one-model`,
				{...inputValue},
				{withCredentials:true}
			)
			const {success,message} = data
			if(success) {
				handleSuccess(message)
				getUserModels()
			}else{
				handleError(data)
			}
		}catch(error){
			console.log(error)
		}
		setInputValue({
			...inputValue,
			name:"",
			status:"not-started",
			list:"",
			points:""
		})
	}

	const handleOpenListModal = () => {
		setListModalOpen(true);
	}
	const handleCloseListModal = () => {
		setListModalOpen(false);
	}

	const editThisModel = (model) => {
		setSelectedModel(model);
		setEditModalOpen(true);
	}

	const handleSearchSubmit = async(e) => {
		e.preventDefault()
    // console.log(e.target[0])
    // console.log(e.target[0].value)
    let searchedTerm = e.target[0].value
    setSearchTerm(searchedTerm)
		try{
	      const {data} = await axios.post(
	        `${process.env.REACT_APP_WEB_URL}api/models/search-by-name`,
	        {
	          searchedTerm: searchedTerm,
	          
	        },
	        {withCredentials:true}
	      )
	      const {message,result} = data
	      // console.log('data')
	      // console.log(data.foundModels)
	      // console.log('---')
	      setUserModels(data.foundModels)
    	}catch(error){
      		console.log(error)
		}
	}

	const handleOnSearchChange = async(e) => {
		const {name,value} = e.target
		setSearchTerm(value)
	}

	const clearSearch = () => {
		setSearchTerm('')
		getUserModels()
	}

  const getUserModels = async() => {
    try {
      const {data} = await axios.post(
        `${process.env.REACT_APP_WEB_URL}api/models/get-user-models`,
        {},
        {withCredentials:true}
      )
      const {message,userModels} = data
      
      const lists = [];
      const listIds = new Set();
      userModels.forEach(m => {
          if (m.list && !listIds.has(m.list._id)) {
              listIds.add(m.list._id);
              lists.push(m.list);
          }
      });
      setUserLists(lists);
      
      setUserModels(userModels)
    }catch(error){
      console.log(error)
    }
  }

  const deleteThisModel = async(deletedModelID) => {
    try {
      const {data} = await axios.post(
        `${process.env.REACT_APP_WEB_URL}api/models/delete-one-model`,
        {
           
          id: deletedModelID
        },
        {withCredentials:true}
      )
      const {success,message} = data
      if(success) {
        handleSuccess(message)
        getUserModels()
        setTimeout(() => {
          toast('Model deleted successfully',{
            position:'bottom-left'
          })
        },500)
      }else{
        handleError(data)
      }
    }catch(error){
      console.log(error)
    }
  }

  useEffect(() => {
    if (user?.user_id) getUserModels()
  }, [user?.user_id])

  const handleFilterChange = async(e) => {
  	e.preventDefault()
  	// console.log(e)
  	// console.log(e.target.getAttribute('data-attr-status'))
  	e.target.classList.toggle('active')
  	if(!modelFilter?.includes(e.target.getAttribute('data-attr-status'))) {
  		setModelFilter([...modelFilter, e.target.getAttribute('data-attr-status')])
  	} else {
  		let modelFilterSpliced = [...modelFilter]
  		modelFilterSpliced.splice(modelFilter.indexOf(e.target.getAttribute('data-attr-status')), 1)
  		setModelFilter(modelFilterSpliced)
  	}
  	return
  }

  const filterModels = async(filters, lFilter) => {
  	try {
        if (!filters?.length && !lFilter) {
            getUserModels();
            return;
        }
  		const {data} = await axios.post(
  			`${process.env.REACT_APP_WEB_URL}api/models/filter-by-status`,
  			{
  				
  				modelFilter: filters,
                listFilter: lFilter
  			},
  			{withCredentials:true}
  		)
  		const {message,foundModels} = data
  		setUserModels(foundModels)
  	} catch(error) {
  		console.log(error)
  	}
  }

  useEffect(() => {
  	if (user?.user_id) filterModels(modelFilter, listFilter)
  }, [modelFilter, listFilter, user?.user_id])
	//***********//
	const totalModels = userModels?.length || 0;
	const completeCount = userModels?.filter(m => m.status === 'complete').length || 0;
	const inProgressCount = userModels?.filter(m => m.status === 'in-progress').length || 0;
	const notStartedCount = userModels?.filter(m => m.status === 'not-started').length || 0;
	const notOwnedCount = userModels?.filter(m => m.status === 'not-owned').length || 0;

	return (
		<>
            <div className="manage-your-models-container">
			    <div className="manage-your-models">
                    <div className="models-top-nav">
                    <a href="/" onClick={(e) => { e.preventDefault(); navigate('/'); }} className="back-link">
                        &lt; Back to Home
                    </a>
                </div>
				<div className="models-toolbar">
					<div className="search-container">
						<form onSubmit={handleSearchSubmit} className="search-form">
							<input 
								type="text"
								name="search_term"
								value={searchTerm}
								placeholder="Search for a model..."
								onChange={handleOnSearchChange}
                                className="search-input"
							/>
							<button type="submit" className="search-button">Search</button>
						</form>
					</div>
					<div className="toolbar-actions">
                        <button className="btn-outline pill" onClick={handleOpenListModal}>Manage Lists</button>
					    <button className={`btn-outline pill ${showFilters ? 'active' : ''}`} style={showFilters ? { background: 'black', color: 'white' } : {}} onClick={() => setShowFilters(!showFilters)}>Filters</button>
                    </div>
				</div>
                
                {showFilters && (
                    <div className="models-filters-container">
                        <div className="filter-group">
                            <span className="filter-label">Status:</span>
                            <button className={`filter-pill ${modelFilter.includes('complete') ? 'active' : ''}`} onClick={handleFilterChange} data-attr-status="complete">Completed</button>
                            <button className={`filter-pill ${modelFilter.includes('in-progress') ? 'active' : ''}`} onClick={handleFilterChange} data-attr-status="in-progress">Built</button>
                            <button className={`filter-pill ${modelFilter.includes('not-started') ? 'active' : ''}`} onClick={handleFilterChange} data-attr-status="not-started">Owned</button>
                            <button className={`filter-pill ${modelFilter.includes('not-owned') ? 'active' : ''}`} onClick={handleFilterChange} data-attr-status="not-owned">Missing</button>
                        </div>
                        <div className="filter-group" style={{ marginLeft: '1rem' }}>
                            <span className="filter-label">List:</span>
                            <select className="pill-input filter-select" value={listFilter} onChange={(e) => setListFilter(e.target.value)}>
                                <option value="">All Models</option>
                                {userLists.map(l => (
                                    <option key={l._id} value={l._id}>{l.name}</option>
                                ))}
                            </select>
                        </div>
                    </div>
                )}
				<div className="row models-main-content">
					<div className="col-md-6 col-12">
						<MODEL_LIST 
			              deleteThisModel={deleteThisModel} 
			              editThisModel={editThisModel}
			              getUserModels={getUserModels} 
			              userModels={userModels} 
			              searchTerm={searchTerm}
			              clearSearch={clearSearch}
			            />
					</div>
					<div className="col-md-6 col-12">
						<div className="overview-section">
                            <p className="overview-stat"><strong>{totalModels} Models</strong></p>
                            <p className="overview-stat"><strong>{completeCount} Complete</strong></p>
                            <p className="overview-stat"><strong>{inProgressCount} Built But Unpainted</strong></p>
                            <p className="overview-stat"><strong>{notStartedCount} Owned But Not Built</strong></p>
                            <p className="overview-stat"><strong>{notOwnedCount} Not Owned</strong></p>
                            
                            <div className="overview-progress-bar">
                                {totalModels > 0 && (
                                    <>
                                        <div className="progress-segment complete" style={{ width: `${(completeCount / totalModels) * 100}%` }}>
                                            <div className="segment-tooltip">
                                                <strong>Complete</strong><br/>
                                                Count: {completeCount}<br/>
                                                {((completeCount / totalModels) * 100).toFixed(1)}%
                                            </div>
                                        </div>
                                        <div className="progress-segment in-progress" style={{ width: `${(inProgressCount / totalModels) * 100}%` }}>
                                            <div className="segment-tooltip">
                                                <strong>Built But Unpainted</strong><br/>
                                                Count: {inProgressCount}<br/>
                                                {((inProgressCount / totalModels) * 100).toFixed(1)}%
                                            </div>
                                        </div>
                                        <div className="progress-segment not-started" style={{ width: `${(notStartedCount / totalModels) * 100}%` }}>
                                            <div className="segment-tooltip">
                                                <strong>Owned But Not Built</strong><br/>
                                                Count: {notStartedCount}<br/>
                                                {((notStartedCount / totalModels) * 100).toFixed(1)}%
                                            </div>
                                        </div>
                                        <div className="progress-segment not-owned" style={{ width: `${(notOwnedCount / totalModels) * 100}%` }}>
                                            <div className="segment-tooltip">
                                                <strong>Not Owned</strong><br/>
                                                Count: {notOwnedCount}<br/>
                                                {((notOwnedCount / totalModels) * 100).toFixed(1)}%
                                            </div>
                                        </div>
                                    </>
                                )}
                            </div>
                        </div>

						<form onSubmit={handleAddModelSubmit} className="add-model-form">
							<div className="form__group">
								<label htmlFor="name" style={{display: 'none'}}>Name</label>
								<input 
									required 
									type="text"
									name="name"
									value={name}
									placeholder="Model name..."
									onChange={handleOnChange}
                                    className="pill-input"
								/>
							</div>
							<div className="form__group">
								<label htmlFor="list" style={{display: 'none'}}>List</label>
								<input 
									required 
									type="text"
									name="list"
									value={list}
									placeholder="Add to list..."
									onChange={handleOnChange}
                                    className="pill-input"
								/>
							</div>
							<div className="form__group">
								<label htmlFor="status" style={{display: 'none'}}>Status</label>
								<select 
									name="status" 
									id="status"
									onChange={handleOnSelectChange} 
									value={inputValue.status}
                                    className="pill-input">
									<option value="not-started">Status: Owned But Not Built</option>
									<option value="in-progress">Status: Built But Unpainted</option>
									<option value="complete">Status: Complete</option>
                                    <option value="not-owned">Status: Not Owned</option>
								</select>
							</div>

                            {/* Hidden legacy fields */}
							<div style={{display: 'none'}}>
								<label htmlFor="points">Points</label>
								<input 
									type="number"
									name="points"
									value={points}
									placeholder="Points"
									onChange={handleOnChange}
								/>
							</div>
							<div style={{display: 'none'}}>
								<label htmlFor="goal_type">Schedule</label>
								<select 
									name="goal_type" 
									id="goal_type">
									<option value="yearly">Yearly</option>
									<option value="quarterly">Quarterly</option>
									<option value="subgoal">Sub Goal</option>
								</select>
							</div>
							<div id="yearly-dropdown" style={{display: 'none'}}>
								<label htmlFor="yearly_goal_year">Year</label>
								<select name="yearly_goal_year" id="yearly_goal_year">
									<option value="2025">2025</option>
								</select>
							</div>
							<div id="quarterly-dropdown" style={{display: 'none'}}>
								<label htmlFor="quarterly_goal_quarter">Quarter</label>
								<select name="quarterly_goal_quarter" id="quarterly_goal_quarter">
									<option value="1">1</option>
								</select>
							</div>
							<div id="subgoal-dropdown" style={{display: 'none'}}>
								<label htmlFor="goal_type">Parent Goal</label>
							</div>
								
							<button type="submit" className="btn-solid-gray pill u-mt-small">Add Model</button>
						</form>

                        {/* CSV Import */}
                        <div className="csv-import-section u-mt-large">
                            <button 
                                className="btn-outline pill button-full-width" 
                                onClick={() => document.getElementById('csvInput').click()}
                                type="button"
                            >
                                Import from CSV
                            </button>
                            <div style={{ display: 'none' }}>
                                <input
                                    onChange={(e) => {
                                        handleCsvFileChange(e);
                                        setTimeout(() => {
                                            document.getElementById('csvParseBtn').click();
                                        }, 100);
                                    }}
                                    id="csvInput"
                                    name="csvFile"
                                    type="file"
                                    accept=".csv"
                                />
                                <button onClick={handleCsvParse} id="csvParseBtn">Parse</button>
                            </div>
                            <div style={{ marginTop: "1rem", fontSize: "0.8rem", color: "red" }}>
                                {csvError ? csvError : ""}
                            </div>
                        </div>
					</div>
				</div>
			</div>
                <div className="models-ad-container">
                    <div className="ad-banner ad-banner--portrait">
                        Possible advertising space
                    </div>
                </div>
            </div>
			<LIST_MODAL 
				isOpen={isListModalOpen}
				onClose={handleCloseListModal}
				onListChange={getUserModels}
			 	 
			/>
			<EDIT_MODEL_MODAL
				isOpen={isEditModalOpen}
				onClose={() => setEditModalOpen(false)}
				model={selectedModel}
				
				getUserModels={getUserModels}
			/>
			<ToastContainer />
		</>
	);
};

export default Models